﻿import * as React from "react";
import { IReturnModel } from "../";

export interface IFileElementProps {
    file: File;
    postURL: string;
    removeFileCallback: (file: File) => void;
    onCompleteCallback: (fileName: string) => void;
}

export interface IFileElementState {
    progressPercent: number;
}

export class FileElement extends React.Component<
    IFileElementProps,
    IFileElementState
> {
    constructor(props: IFileElementProps) {
        super(props);

        this.state = {
            progressPercent: 0,
        };
    }

    componentDidMount(): void {
        this._readFile();
    }

    private _task: JQuery.jqXHR;

    private _reader: FileReader;

    private readonly _readFile = (): void => {
        this._reader = new FileReader();
        this._reader.onload = this._uploadFile;
        this._reader.readAsDataURL(this.props.file);
    };

    private readonly _uploadFile = (): void => {
        const settings: JQuery.AjaxSettings = {
            data: {
                fileName: this.props.file.name,
                fileURI: this._reader.result,
            },
            method: `POST`,
            url: this.props.postURL,
            xhr: this._createXHR,
        };

        this._task = $.ajax(settings);
    };

    private readonly _createXHR = (): XMLHttpRequest => {
        const xhr: XMLHttpRequest = new XMLHttpRequest();

        const onProgress: (e: ProgressEvent) => void = (e) => {
            this.setState({
                progressPercent: (e.loaded / e.total) * 100,
            });
        };

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const onEnd: (e: ProgressEvent) => void = (e) => {
            this.setState({
                progressPercent: 100,
            });
            this.props.onCompleteCallback(this.props.file.name);
        };

        xhr.upload.onprogress = onProgress;
        xhr.upload.onloadend = onEnd;
        return xhr;
    };

    private readonly _removeFile = async (): Promise<boolean> => {
        const stringResult: string = await $.ajax(this.props.postURL, {
            data: {
                fileName: this.props.file.name,
            },
            method: `DELETE`,
        });

        const result: IReturnModel<null> = JSON.parse(stringResult);

        return result.isSuccess;
    };

    private readonly _handleRemoveClick = (): void => {
        if (this._removeFile()) {
            this.props.removeFileCallback(this.props.file);
        }
    };

    render(): React.ReactElement {
        let progressString: string = this.state.progressPercent.toString();

        const progressInt: number = parseInt(progressString);

        progressString = progressInt.toString();

        return (
            <div className={`fileelement`}>
                <img src={`/Images/UI/UploadIconGreen.svg`} />
                <div className={`fileelement-properties`}>
                    <div className={`fileelement-name`}>
                        {this.props.file.name}
                    </div>
                    <div className={`fileelment-info`}>
                        Uploading {progressString}%
                    </div>
                    <div className={`fileelement-progress`}>
                        <div
                            className={`fileelement-progressbar`}
                            style={{
                                width: `${this.state.progressPercent}%`,
                            }}
                        />
                    </div>
                </div>
                <div className={`fileelement-close`}>
                    <img
                        onClick={this._handleRemoveClick}
                        src={`/Images/CloseIcon.svg`}
                    />
                </div>
            </div>
        );
    }
}
